import styled, { css } from 'styled-components';
import { CircularIconProps } from './CircularIcon';


export const CircularIconContainer = styled.div<CircularIconProps>`
	${({ theme, size }) => css`
		width: ${size}px;
		min-width: ${size}px;
		height: ${size}px;
		background-color: ${theme.colors.brand.primary.background};
		border-radius: ${theme.radii.full};
		box-shadow: ${theme.shadows.base};

		display: grid;
		place-content: center;
	`}
`;
